import * as React from 'react';
import {MeetingObj} from '../../Entity/Objmeeting';
import './Report.scss';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint, IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';


export interface IProps{
  meeting?: MeetingObj; 
  UpdateMethod; 
  LogTitle;
  savesummary;
}
export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;
  DetailCalloutVisible?: boolean;  
  Summary:string;
}
export default class MeetingReportSummaryEdit extends React.Component<IProps,IContextualMenuState,IContextualMenuItem>{
  /*state: IProps = {
   
  };*/
  private _menuButtonElement: HTMLElement | null;

  constructor(props: IProps) {
    super(props);  
    this.state = {
      isCalloutVisible: false,  
      DetailCalloutVisible:false,    
      directionalHint: DirectionalHint.topCenter,
      beakWidth:16,
      Summary:props.meeting.Summary
    }; 
  }
  public render() {
    //let firstDayOfWeek= DayOfWeek.Monday;
    
    const { isCalloutVisible,beakWidth,Summary } = this.state;
    


    return (
        
        <label id={'Callout_Meeting'+this.props.meeting.ID} title={this.props.meeting.Summary} ref={menuButton => (this._menuButtonElement = menuButton)}>
                <i className='ms-Icon ms-Icon--ActivityFeed' onClick={this._onShowMenuClicked} ></i>
                
                {isCalloutVisible ? (
                              <Callout
                                
                                className="ms-Callout-callout"
                                onDismiss={this._onCalloutDismiss}
                                target={this._menuButtonElement}
                                //directionalHint={directionalHint}
                                coverTarget={false}
                                isBeakVisible={true}
                                gapSpace={0}
                                beakWidth={beakWidth}
                              >
           
                              <div className="ms-Callout-inner" style={{padding:'10px'}}>
                                <div className="ms-Callout-content">
                                <i style={{fontSize:20,float:'left',marginRight:5,color:'#0098d9',cursor:'pointer'}} onClick={this.AddSummary} className="timestamp ms-Icon ms-Icon--BufferTimeBoth"></i>
                                <textarea onChange={this.handleLogChange} cols={40} rows={10} value={Summary}></textarea>
                                  
                                </div>
                                <div style={{textAlign:"right",padding:5}}>
                                    <DefaultButton className="reportbutton"  
                                                  onClick={(event)=>{
                                                    this.UpdateMeetingValue(this.props.meeting.ID,this.state.Summary,'IGlobeCRM_Summary','Note',this.props.meeting.MeetingColmn);
                                                    this._onCalloutDismiss();
                                                    }} text={this.props.savesummary} />
                                </div>
            </div>
          </Callout>
        ) : null} 
        </label> 
      
    );
  }
  public UpdateMeetingValue(itemId,newValue,propName,type,col){
    let obj = {
              listtitle: 'CRM Meeting Report',
              ID:itemId,
              fieldslist: [{
                spfieldname:propName,
                spvalue:newValue,
                spfieldtype:type
              }]
          };
     this.props.UpdateMethod(obj,col,false);
  }
  public handleLogChange= (event): void => {
    this.setState({Summary: event.target.value});
  }
  public AddSummary=(event)=>{
    let summarytext=this.state.Summary;
    if (summarytext == "") {
      summarytext=this.props.LogTitle;
  }
  else {
    summarytext=this.props.LogTitle + "\n\n" + summarytext;
  }
    this.setState({Summary:summarytext});
  }
  private _onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false
    });
  }

  private _onShowMenuClicked = (): void => {
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  }

  /*private _onDetailCalloutDismiss = (): void => {
    this.setState({
      DetailCalloutVisible: false
    });
  }

  private _onDetailShowMenuClicked = (): void => {
    this.setState({
      DetailCalloutVisible: !this.state.DetailCalloutVisible
    });
  }*/
}
